import generateBasicEntityActions from "./generateBasicEntityActions";

const assetClassificationActions = generateBasicEntityActions(
  "assetClassifications",
  "assetClassification"
);

export default assetClassificationActions;
